import StudentAssignmentsListController from "./StudentAssignmentsList.controller"

interface StudentAssignmentsListProps {
  controller: StudentAssignmentsListController
}

export function StudentAssignmentsList({
  controller,
}: StudentAssignmentsListProps) {
  return <div>StudentAssignmentsList Component</div>
}
